function NRRiseAIAnimatedBorder({ dims, perimeter, visible, stroke }) {
  if (!dims || perimeter <= 0) return null;

  return (
    <svg
      aria-hidden="true"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        overflow: 'visible'
      }}
    >
      <rect
        x="0.5"
        y="0.5"
        width={dims.width - 1}
        height={dims.height - 1}
        rx={(dims.height - 1) / 2}
        ry={(dims.height - 1) / 2}
        fill="none"
        stroke={stroke}
        strokeWidth="1"
        strokeDasharray={perimeter}
        strokeDashoffset={visible ? 0 : perimeter}
        style={{ transition: 'stroke-dashoffset 1s cubic-bezier(0.16, 1, 0.3, 1)' }}
      />
    </svg>
  );
}

export default NRRiseAIAnimatedBorder;
